import claudiImg from '../content/characters_icon/claudi.png';
import eddyImg from '../content/characters_icon/eddy.png';
import rockImg from '../content/characters_icon/rock.png';
import tuchiImg from '../content/characters_icon/tuchi.png';
import ufoImg from '../content/characters_icon/ufo.png';
import vallImg from '../content/characters_icon/vall.png';
import './CharacterIcon.css';

const CHARACTER_ICON_IMAGES = {
  claudi: claudiImg,
  eddy: eddyImg,
  rock: rockImg,
  tuchi: tuchiImg,
  ufo: ufoImg,
  vall: vallImg,
} as const;

export type FailDeliveryCharacterId = keyof typeof CHARACTER_ICON_IMAGES;

type CharacterLayout = {
  left: number;
  top: number;
  width: number;
  height: number;
};

/** Positions from Figma game_over_screen character placements. */
const CHARACTER_ICON_LAYOUT: Record<FailDeliveryCharacterId, CharacterLayout> =
  {
    claudi: { left: 270, top: 872, width: 431, height: 669 },
    tuchi: { left: 30, top: 709, width: 378, height: 540 },
    ufo: { left: 233, top: 894, width: 604, height: 532 },
    vall: { left: -195, top: 842, width: 817, height: 576 },
    rock: { left: 70, top: 874, width: 926, height: 1046 },
    eddy: { left: 487, top: 748, width: 456, height: 501 },
  };

export type CharacterIconProps = {
  characterId?: FailDeliveryCharacterId;
};

/** Fail-delivery character art keyed by character id. */
export function CharacterIcon({
  characterId = 'eddy',
}: CharacterIconProps) {
  const layout = CHARACTER_ICON_LAYOUT[characterId];

  return (
    <img
      className="fail-delivery-character-icon"
      src={CHARACTER_ICON_IMAGES[characterId]}
      alt=""
      draggable={false}
      aria-hidden
      style={{
        left: layout.left,
        top: layout.top,
        width: layout.width,
        height: layout.height,
      }}
    />
  );
}
